<router-outlet></router-outlet>
<ng-keyboard-shortcuts-help [key]="'F1'"
  [closeKey]="'escape'"
  i18n-title="@@keyboard_shortcuts_help.title"
  title="Shortcuts Help"
  i18n-emptyMessage="@@keyboard_shortcuts_help.empty_message"
  emptyMessage="No shortcuts available"
></ng-keyboard-shortcuts-help>
@if (fieldTokenConnectorService.enabled$ | async) {
  <app-field-token-connector></app-field-token-connector>
}

<div id="tenant-switch-typeahead-container"></div>
